<template>
  <svg width="36" height="34" viewBox="0 0 36 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.1422 8.81575V7.94941C10.1992 5.6929 10.9912 3.81709 12.5183 2.32199C14.0453 0.826883 15.9688 0.0528869 18.2888 0C20.6087 0.0528869 22.5322 0.826883 24.0593 2.32199C25.5863 3.81709 26.3783 5.6929 26.4354 7.94941V8.81575H31.994C32.3615 8.81575 32.6657 8.92068 32.9065 9.13055C33.1472 9.34042 33.2957 9.61577 33.3518 9.95659L35.77 32.6224C35.827 32.9901 35.7211 33.3116 35.4523 33.587C35.1834 33.8623 34.8512 34 34.4557 34H2.12321C1.72674 34 1.39454 33.8623 1.12661 33.587C0.858675 33.3116 0.752769 32.9901 0.80889 32.6224L3.22707 9.95659C3.2841 9.61577 3.43255 9.34042 3.67242 9.13055C3.91229 8.92068 4.21643 8.81575 4.58484 8.81575H10.1435H10.1422ZM12.8577 8.81575H23.7198V7.94941C23.6918 6.40142 23.1613 5.11576 22.1285 4.09244C21.0957 3.06912 19.8158 2.54445 18.2888 2.51843C16.7608 2.54445 15.4809 3.06912 14.449 4.09244C13.4171 5.11576 12.8867 6.40142 12.8577 7.94941V8.81575ZM10.1422 11.3342H5.81361L3.64934 31.4816H32.9268L30.7625 11.3342H26.434V15.1118C26.434 15.4795 26.3068 15.7813 26.0525 16.0172C25.7981 16.2531 25.4727 16.371 25.0762 16.371C24.6798 16.371 24.3543 16.2531 24.1 16.0172C23.8456 15.7813 23.7185 15.4795 23.7185 15.1118V11.3342H12.8563V15.1118C12.8563 15.4795 12.7292 15.7813 12.4748 16.0172C12.2205 16.2531 11.895 16.371 11.4986 16.371C11.1021 16.371 10.7767 16.2531 10.5223 16.0172C10.268 15.7813 10.1408 15.4795 10.1408 15.1118V11.3342H10.1422Z" fill="#43D3B3"/>
  </svg>
</template>

<script>
export default {
  name: 'Sales',
  props: {

  },
  computed: {

  }
};
</script>
<style scoped lang="scss">

</style>
